export default __webpack_public_path__ + "static/Retail-hero-6a61cd27b41bce3a8c34e059f1ffa864.png";